import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Vue.use(Router)

export const constantRoutes = [{
        path: "/",
        component: Layout,
        hidden: true,
        children: [{
            path: "/",
            component: (resolve) =>
                require(["@/views/redirect.vue"], resolve),
        }, ],
    },
    {
        path: "",
        component: Layout,
        redirect: "index",
        children: [{
            path: "/index",
            component: (resolve) => require(["@/views/index.vue"], resolve),
            name: "首页",
            meta: {
                title: "首页",
                icon: "dashboard",
                noCache: true,
                affix: true,
            },
        }, ],
    },
    {
        path: "",
        component: Layout,
        children: [{
            path: "/MeetingManagement",
            component: (resolve) =>
                require(["@/views/MeetingManagement/index.vue"], resolve),
            name: "会议管理",
            meta: {
                title: "会议管理",
                icon: "dashboard",
                noCache: true,
                affix: true,
            },
        }, ],
    },
    {
        path: "",
        component: Layout,
        children: [{
            path: "/PeriodicalManagement",
            component: (resolve) =>
                require([
                    "@/views/PeriodicalManagement/index.vue",
                ], resolve),
            name: "期刊管理",
            meta: {
                title: "期刊管理",
                icon: "dashboard",
                noCache: true,
                affix: true,
            },
        }, ],
    },
    {
        path: "",
        component: Layout,
        children: [{
            path: "/CallforPapers",
            component: (resolve) =>
                require([
                    "@/views/CallforPapers/index.vue",
                ], resolve),
            name: "专刊管理",
            meta: {
                title: "专刊管理",
                icon: "dashboard",
                noCache: true,
                affix: true,
            },
        }, ],
    },
    {
        path: "",
        component: Layout,
        children: [{
            path: "/NoticeAnnouncement",
            component: (resolve) =>
                require([
                    "@/views/NoticeAnnouncement/index.vue",
                ], resolve),
            name: "通知公告",
            meta: {
                title: "通知公告",
                icon: "dashboard",
                noCache: true,
                affix: true,
            },
        }, ],
    },
    {
        path: "",
        component: Layout,
        children: [{
            path: "/PostManagement",
            component: (resolve) =>
                require(["@/views/PostManagement/index.vue"], resolve),
            name: "岗位管理",
            meta: {
                title: "岗位管理",
                icon: "dashboard",
                noCache: true,
                affix: true,
            },
        }, ],
    },
    {
        path: "",
        component: Layout,
        children: [{
            path: "/ProblemFeedback",
            component: (resolve) =>
                require([
                    "@/views/ProblemFeedback/index.vue",
                ], resolve),
            name: "问题反馈",
            meta: {
                title: "问题反馈",
                icon: "dashboard",
                noCache: true,
                affix: true,
            },
        }, ],
    },
    {
        path: "",
        component: Layout,
        children: [{
            path: "TimedTask",
            component: (resolve) =>
                require(["@/views/TimedTask/index.vue"], resolve),
            name: "定时任务",
            meta: {
                title: "定时任务",
                icon: "dashboard",
                noCache: true,
                affix: true,
            },
        }, ],
    },
    {
        path: "/SystemManagement",
        component: Layout,
        children: [{
                path: "Discipline",
                component: (resolve) =>
                    require([
                        "@/views/SystemManagement/Discipline.vue",
                    ], resolve),
                name: "学科管理",
                meta: {
                    title: "学科管理",
                    icon: "dashboard",
                    noCache: true,
                    affix: true,
                },
            },
            {
                path: "classification",
                component: (resolve) =>
                    require([
                        "@/views/SystemManagement/classification.vue",
                    ], resolve),
                name: "分类管理",
                meta: {
                    title: "分类管理",
                    icon: "dashboard",
                    noCache: true,
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/login",
        name: "登录",
        component: (resolve) => require(["@/views/login.vue"], resolve),
    },
    {
        path: "/404",
        component: (resolve) => require(["@/views/error/404.vue"], resolve),
        hidden: true,
    },
    {
        path: "/401",
        component: (resolve) => require(["@/views/error/401.vue"], resolve),
        hidden: true,
    },
];

export default new Router({
    // mode: 'history', // 去掉url中的#
    scrollBehavior: () => ({
        y: 0
    }),
    routes: constantRoutes
})
